import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {
  LoadCasaSettingsFail,
  LoadCasaSettingsSuccess,
  CasaSettingsActionTypes
} from './actions';
import { CasaSettingsService } from '../../services/casa-settings.service';

@Injectable()
export class CasaSettingsEffects {
  @Effect()
  public loadSettings$: Observable<
    LoadCasaSettingsFail | LoadCasaSettingsSuccess
  > = this.actions$.pipe(
    ofType(CasaSettingsActionTypes.Load),
    exhaustMap(() =>
      this.settingsService.getSettings().pipe(
        map(settings => new LoadCasaSettingsSuccess(settings)),
        catchError(error =>
          of(new LoadCasaSettingsFail(error && (error as Error).message))
        )
      )
    )
  );

  constructor(
    public settingsService: CasaSettingsService,
    private actions$: Actions
  ) {}
}
